var app = angular.module("leonardo");

var SystemTagAddDialog = function ($scope, FormErrorsService, AuthDataService, DeficiencyTagService, $rootScope, NotificationService) {
  $scope.mode = $scope.ngDialogData.mode;
  $scope.data = {};

  if ($scope.mode === 'edit') {
    var Tagdata = angular.copy($scope.ngDialogData.tag);
    if (AuthDataService.isAdmin()) {
      $scope.data.tagName = Tagdata.tag_name;
      $scope.data.tagLabel = 'Attribute/Description name';
    }
    else {
      $scope.data.tagName = Tagdata.display_name;
      $scope.data.tagLabel = 'Display Name';
    }
  }
  else {
    $scope.data.tagLabel = 'Attribute/Description name';
  }

  $scope.clearError = function () {
    $scope.Form.name.$setValidity('unique', true);
    $scope.Form.name.$setValidity('uniquedisplay', true);
  };

  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var reqdata = {};
    if ($scope.mode === 'edit') {
      var tagData = angular.copy($scope.ngDialogData.tag)
      if (AuthDataService.isAdmin()) {
        reqdata.tag_name = $scope.data.tagName;
      }
      else {
        reqdata.display_name = $scope.data.tagName;
        reqdata.tag_name = tagData.tag_name;
      }
      DeficiencyTagService.updateTag(reqdata, tagData.id).then(function () {
        NotificationService.notify('success', 'Tag name has been saved successfully');
        $rootScope.$broadcast('deficiency-tags:updated');
        $scope.closeThisDialog();
      }, function (error) {
        if ((error.data.tag_name && error.data.tag_name[0] === 'This field must be unique.')) {
          $scope.Form.name.$setValidity('unique', false);
        }
        if((error.data.non_field_errors && error.data.non_field_errors[0] === 'You have already defined this display name for another tag.')) {
          $scope.Form.name.$setValidity('uniquedisplay', false);
        }
      });
    }
    else {
      reqdata = {
        "tag_name": $scope.data.tagName,
        "is_active": true,
        "allow_use_in_dynamic_forms": true,
        "allow_use_in_reports": true
      }
      DeficiencyTagService.createTag(reqdata).then(function () {
        NotificationService.notify('success', 'Tag has been created successfully');
        $rootScope.$broadcast('deficiency-tags:updated');
        $scope.closeThisDialog();
      }, function(error) {
        if (error.data.tag_name && error.data.tag_name[0] === 'This field must be unique.') {
          $scope.Form.name.$setValidity('unique', false);
        }
      })
    }
  };

};

app.controller('SystemTagAddDialog', ['$scope', 'FormErrorsService', 'AuthDataService','DeficiencyTagService','$rootScope', 'NotificationService', SystemTagAddDialog]);
